export const DESCRIPTION = 'Notes';

export const NOTES_MODAL_ID = 'notes-mobile-modal';
